export type ButtonVariant =
  | 'flat'
  | 'primary'
  | 'flatDanger'
  | 'danger'
  | 'flatDark'
  | 'trial'
  | 'flatTrial'
  | 'ghost'
  | 'ghostDark'
  | 'ghostCarbon200'
  | 'ghostCarbon300'
  | 'ghostTrial'
  | 'emailAgent';
